export default [
  {
    header: '经纪招商',
    resource: 'broker',
    action: 'index',
  },
  {
    title: '经纪人管理',
    icon: 'UsersIcon',
    route: 'broker-manage',
    resource: 'broker-manage',
    action: 'index',
  },
  {
    title: '经纪人客户',
    icon: 'TvIcon',
    route: 'broker-customer',
    resource: 'broker-customer',
    action: 'index',
  },
  {
    title: '客户预约单',
    icon: 'TruckIcon',
    route: 'customer-appointment',
    resource: 'broker-appointment',
    action: 'index',
  },
  {
    title: '推介客户单',
    icon: 'ClipboardIcon',
    route: 'recommend-customer',
    resource: 'broker-recommend',
    action: 'index',
  },
  {
    title: '客户确认书',
    icon: 'BookOpenIcon',
    route: 'customer-confirm',
    resource: 'broker-confirm',
    action: 'index',
  },
]
